import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAsync } from 'react-use';
import styled from '@emotion/styled';
import { gutters } from 'app/spacing';
import { fontSizes } from 'app/typography';
import KizenTypography from 'app/kizentypo';
import Select from 'components/Inputs/Select';
import CustomObjectsService from 'services/CustomObjectsService';
import { buildJsActionKey } from 'ts-components/Plugins/jsActions';

const SectionHeading = styled.div`
  line-height: 1;
  margin-bottom: ${gutters.spacing(4, { baseline: fontSizes.subheader })}px;
`;

const SelectWrapper = styled.div`
  max-width: 320px;
  margin-bottom: ${gutters.spacing(6)}px;
`;

const STANDARD_FORM_VALUE = null;
const EMPTY_ARRAY = [];

export const RecordActions = ({ model, updateStepField, setDirty }) => {
  const { t } = useTranslation();
  const [jsActions, setJsActions] = useState(EMPTY_ARRAY);

  const { loading } = useAsync(async () => {
    if (!model.id) return;
    const details = await CustomObjectsService.getCustomObjectDetails(model.id);
    setJsActions(details.browserJsActions || EMPTY_ARRAY);
  }, [model.id]);

  const options = [
    { value: STANDARD_FORM_VALUE, label: t('Standard Form') },
    ...jsActions.map((action) => ({
      value: buildJsActionKey(action),
      label: action.name,
    })),
  ];

  const currentValue =
    options.find((o) => o.value === (model.actionOverrideCreate || null)) ||
    options[0];

  const handleChange = ({ value }) => {
    updateStepField('actionOverrideCreate', value || null);
    setDirty(true);
  };

  return (
    <>
      <SectionHeading>
        <KizenTypography type="subheader">
          {t('Record Actions')}
        </KizenTypography>
      </SectionHeading>
      <SelectWrapper>
        <Select
          label={t('Create Record Form')}
          value={currentValue}
          options={options}
          onChange={handleChange}
          isLoading={loading}
          data-qa-id="create-record-form-select"
        />
      </SelectWrapper>
    </>
  );
};
